import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { UserService } from '../shared/services/user.service';
import { UserRole } from '#backend/common/user-types';
import { urls } from '../shared/constants';

/**
 * Guard que verifica se o usuário tem acesso ao menu de administração
 * Apenas Admin Cliente e Admin Geoambiente podem acessar
 */
export const canAdminGuard: CanActivateFn = async () => {
  // Skip guard if debug flag is enabled
  if (environment.skipAuth) {
    return true;
  }

  const userService = inject(UserService);
  const router = inject(Router);

  try {
    const user = await userService.requireUser();

    const isAdminCandidate =
      user.role === UserRole.ADMIN_CLIENTE ||
      user.role === UserRole.ADMIN_GEOAMBIENTE;

    if (isAdminCandidate) {
      return true;
    }

    // Redirecionar para dashboard (menu admin não deveria ser visível para este usuário)
    // verifica papel para evitar loop infinito
    if (user.role === UserRole.VISUALIZADOR_CLIENTE) {
      router.navigateByUrl(urls.customerFacingDashboard, { replaceUrl: true });
    } else {
      router.navigateByUrl('monitoring-safras', { replaceUrl: true });
    }

    return false;
  } catch (error) {
    console.error('[CanAdminGuard] Falha ao carregar usuário', error);
    router.navigate([urls.login]);
    return false;
  }
};
